import React, { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { Group } from "lucide-react";





// Authenticated pages
// const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
// const Collectors = lazy(() => import("../pages/collectors/Collectors"));
// const Customers = lazy(() => import("../pages/customers/Customer"));
// const AddCustomer = lazy(() => import("../pages/customers/AddCustomer"));
// const EditCustomer = lazy(() => import("../pages/customers/EditCustomer"));
// const SchedulePickup = lazy(() => import("../pages/customers/SchedulePickup"));
// const Drivers = lazy(() => import("../pages/drivers/Drivers"));
// const AddDriver = lazy(() => import("../pages/drivers/AddDriver"));
// const EditDriver=lazy(()=>import("../pages/drivers/EditDriver"));
// const Fleets = lazy(() => import("../pages/Fleets/Fleets"));
// const AddFleet = lazy(() => import("../pages/Fleets/AddFleet"));
// const EditFleet = lazy(() => import("../pages/Fleets/EditFleet"));

const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const Collectors = lazy(() => import("../pages/collectors/Collectors"));
const Customers = lazy(() => import("../pages/customers/Customer"));
const AddCustomer = lazy(() => import("../pages/customers/AddCustomer"));
const EditCustomer = lazy(() => import("../pages/customers/EditCustomer"));
const SchedulePickup = lazy(() => import("../pages/customers/SchedulePickup"));
const Drivers = lazy(() => import("../pages/drivers/Drivers"));
const AddDriver = lazy(() => import("../pages/drivers/AddDriver"));
const EditDriver=lazy(()=>import("../pages/drivers/EditDriver"));
const Fleets = lazy(() => import("../pages/Fleets/Fleets"));
const AddFleet = lazy(() => import("../pages/Fleets/AddFleet"));
const EditFleet = lazy(() => import("../pages/Fleets/EditFleet"));
const Complaints=lazy(()=> import("../pages/complaints/Complaints"))
const Notifications=lazy(()=>import("../pages/Notifications/Notifications"))
const Settings=lazy(()=>import("../pages/settings/Settings"))
const WeighBridgeRecords=lazy(()=>import("../pages/weighbridgerecords/WeighBridgeRecords"))
const Payments=lazy(()=>import("../pages/PaymentManagement/Payments"))
const HandoverLogs= lazy(()=>import("../pages/PaymentManagement/HandoverLogs"))
const GroupManagement= lazy(()=>import("../pages/groupmanagement/GroupManagement"))
const RoutePlanner= lazy(()=>import("../pages/routeplanner/RoutePlanner"))
const PickupManagement= lazy(()=>import("../pages/Pickup/PickUpManagement"))
const authenticatedRoutes = [
  // {
  //   path: "/dashboard",
  //   element: (
  //     <ProtectedRoute>
  //       <Dashboard />
  //     </ProtectedRoute>
  //   ),
  // },
  // {
  //   path: "/customers",
  //   element: (
  //     <ProtectedRoute>
  //       <Customers />
  //     </ProtectedRoute>
  //   ),
  // },
  // {
  //   path: "/customers/add",
  //   element: (
  //     <ProtectedRoute>
  //       <AddCustomer />
  //     </ProtectedRoute>
  //   ),
  // },
  // {
  //   path: "/customers/edit/:slug",
  //   element: (
  //     <ProtectedRoute>
  //       <EditCustomer />
  //     </ProtectedRoute>
  //   ),
  // },
  // {
  //   path: "/customers/schedule-pickup",
  //   element: (
  //     <ProtectedRoute>
  //       <SchedulePickup />
  //     </ProtectedRoute>
  //   ),
  // },
  // {
  //   path: "/collectors",
  //   element: (
  //     <ProtectedRoute>
  //       <Collectors />
  //     </ProtectedRoute>
  //   ),
  // },
  // {
  //   path: "/",
  //   element: (
  //     <ProtectedRoute>
  //       <Navigate to="/dashboard" replace />
  //     </ProtectedRoute>
  //   ),
  // },

  // {
  //   path:"/drivers",
  //   element:(
  //     <ProtectedRoute>
  //       <Drivers/>
  //     </ProtectedRoute>
  //     )
  // },
  // {
  //   path:"/drivers/add",
  //   element:(
  //     <ProtectedRoute>
  //       <AddDriver/>
  //     </ProtectedRoute> 
  //     )
  // },
  // {
  //   path:"/drivers/edit/:slug",
  //   element:(
  //     <ProtectedRoute>
  //       <EditDriver/>
  //     </ProtectedRoute> 
  //     )
  // },
  // {
  //   path: "/fleet-management",
  //   element: (
  //     <ProtectedRoute>
  //       <Fleets/>
  //     </ProtectedRoute>
  //   )
  // },
  //   {
  //   path:"/fleets/add",
  //   element:(
  //     <ProtectedRoute>
  //       <AddFleet/>
  //     </ProtectedRoute> 
  //     )
  // },
  //   {
  //   path:"/fleets/edit/:slug",
  //   element:(
  //     <ProtectedRoute>
  //       <EditFleet/>
  //     </ProtectedRoute> 
  //     )
  // },

     {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
     </ProtectedRoute>
    ),
  },
    {
    path: "/customers",
    element: (
      <ProtectedRoute>
        <Customers />
      </ProtectedRoute>
    ),
  },
  {
    path: "/customers/add",
    element: (
      <ProtectedRoute>
        <AddCustomer />
      </ProtectedRoute>
    ),
  },
  {
    path: "/customers/edit/:slug",
    element: (
      <ProtectedRoute>
        <EditCustomer />
      </ProtectedRoute>
    ),
  },
  {
    path: "/customers/schedule-pickup",
    element: (
      <ProtectedRoute>
        <SchedulePickup />
      </ProtectedRoute>
    ),
  },
  {
    path: "/collectors",
    element: (
      <ProtectedRoute>
        <Collectors />
      </ProtectedRoute>
    ),
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    ),
  },

  {
    path:"/drivers",
    element:(
      <ProtectedRoute>
        <Drivers/>
      </ProtectedRoute>
      )
  },
  {
    path:"/drivers/add",
    element:(
      <ProtectedRoute>
        <AddDriver/>
      </ProtectedRoute> 
      )
  },
  {
    path:"/drivers/edit/:slug",
    element:(
      <ProtectedRoute>
        <EditDriver/>
      </ProtectedRoute> 
      )
  },
  {
    path: "/fleet-management",
    element: (
      <ProtectedRoute>
        <Fleets/>
      </ProtectedRoute>
    )
  },
    {
    path:"/fleets/add",
    element:(
      <ProtectedRoute>
        <AddFleet/>
      </ProtectedRoute> 
      )
  },
    {
    path:"/fleets/edit/:slug",
    element:(
      <ProtectedRoute>
        <EditFleet/>
      </ProtectedRoute> 
      )
  },
  {
    path: '/complaints',
    element: (
      <ProtectedRoute>
        <Complaints />
      </ProtectedRoute>
    ),
  },
  {
    path:"/notifications",
    element:(
      <ProtectedRoute>
        <Notifications/>
      </ProtectedRoute>
    ),
  },
  {
    path:"/settings",
    element:(
      <ProtectedRoute>
        <Settings/>
      </ProtectedRoute>
    ),
  },
  {
    path:"/weighbridge-records",
    element:(
      <ProtectedRoute>
        <WeighBridgeRecords/>
      </ProtectedRoute>
    ),
  },
  {
    path:"/payment-management",
    element:(
      <ProtectedRoute>
     <Payments/>
      </ProtectedRoute>
    )
  },
   {
    path:"/handover-logs",
    element:(
      <ProtectedRoute>
     <HandoverLogs/>
      </ProtectedRoute>
    )
  }
  ,
  {
    path: "/group-management",
    element: (
      <ProtectedRoute>
        <GroupManagement />
      </ProtectedRoute>
    ),
  },{
    path:"/route-planner",
    element:(
      <ProtectedRoute>
        <RoutePlanner/>
      </ProtectedRoute>
    )
  },
{
  path:"/pickups",
  element:(
    <ProtectedRoute>
      <PickupManagement/>
    </ProtectedRoute>
  )
}


];

export default authenticatedRoutes;
